<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    :class="{ hideButton: true }"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="140px"
        :model="dataForm"
        :disabled="true"
      >
        <el-form-item label="培训主题：">
          <p>{{ dataForm.Title }}</p>
        </el-form-item>
        <!-- <el-form-item label="截止报名时间：">
          <p>{{ (dataForm.DeadLine * 1000) | formatDate }}</p>
        </el-form-item>
        <el-form-item label="开始培训时间：">
          <p>{{ (dataForm.StartTime * 1000) | formatDate }}</p>
        </el-form-item>
        <el-form-item label="结束培训时间：">
          <p>{{ (dataForm.EndTime * 1000) | formatDate }}</p>
        </el-form-item> -->
        <el-form-item label="培训地址：">
          <p>{{ dataForm.Address }}</p>
        </el-form-item>
        <el-form-item label="报名条件：">
          <p>{{ dataForm.Condition }}</p>
        </el-form-item>
        <el-form-item label="个人费用(元)：">
          <p>{{ dataForm.PersonalCost }}</p>
        </el-form-item>
        <el-form-item label="团体费用(元)：">
          <p>{{ dataForm.GroupCost }}</p>
        </el-form-item>
        <!-- <el-form-item label="最低开班人数(人)：">
          <p>{{ dataForm.MinimumPeople }}</p>
        </el-form-item>
        <el-form-item label="最高开班人数(人)：">
          <p>{{ dataForm.MaximumPeople }}</p>
        </el-form-item> -->
        <!-- <el-form-item label="费用成本说明：">
          <p>{{ dataForm.CostDescription }}</p>
        </el-form-item> -->
        <el-form-item label="联系电话：">
          <p>{{ dataForm.Phone }}</p>
        </el-form-item>

        <!-- <el-form-item label="封面图：">
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            :fileList="pictureList"
            :class="{ hide: hideUploadEdit }"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item> -->
        <el-form-item label="图片：" v-if="dataForm.HeadImge">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            :on-preview="onPicPreview"
            :file-list="pictureList"
          >
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <div style="height: 77vh; overflow: scroll">
              <img style="width: 100%" :src="dialogImageUrl" alt />
            </div>
          </el-dialog>
        </el-form-item>
        <el-form-item label="附件：" v-if="dataForm.File">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
        <el-form-item label="视频：" prop="Video" v-if="dataForm.Video">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-preview="onVideoPreview"
            :file-list="videoList"
            accept="video/*"
          >
          </el-upload>
          <el-dialog :visible.sync="showVideo" :append-to-body="true">
            <div style="height: 77vh; overflow: scroll">
              <video
                style="width: 100%"
                :src="dialogVideoUrl"
                controls="controls"
              />
            </div>
          </el-dialog>
        </el-form-item>
        <el-form-item label="培训介绍：" style="margin-top: 10px">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Abstract"
            :height="500"
            :isEdit="true"
          ></of-tinymce>
        </el-form-item>
        <!-- <el-form-item label="上传附件：">
          <of-upload
            class="upload-demo"
            list-type="fileList"
            @onPreview="onFilePreview"
            :fileList="fileList"
            :class="{ hideFile: hideUploadFileEdit }"
          >
            <div slot="content">
              <el-button size="mini">
                <i class="el-icon-upload el-icon--left"></i>上传文件
              </el-button>
            </div>
          </of-upload>
        </el-form-item> -->
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pictureList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      hideUploadEdit: false,
      hideUploadFileEdit: false,
      width: "60%",
      dataForm: {},
      showVideo: false,
      dialogVideoUrl: "",
      videoList: [],
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce,
  },
  methods: {
    //加载数据
    loadData() {
      let params = { id: this.id };
      api.QueryTrainById(params).then((res) => {
        if (res.data.Code === 0) {
          this.dataForm = res.data.Data;
          this.getImg();
          this.getFile();
          this.getVideo();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //查看图片
    // onPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    //初始化封面图
    // getImg() {
    //   if (
    //     this.dataForm.HeadImge === undefined ||
    //     this.dataForm.HeadImge === null ||
    //     this.dataForm.HeadImge == ""
    //   ) {
    //     return;
    //   }
    //   this.hideUploadEdit = true;
    //   this.$http
    //     .get("/Sys/File/Download?Id=" + this.dataForm.HeadImge)
    //     .then((res) => {
    //       let pictureList = [res.config];
    //       this.pictureList = pictureList.map((item) => {
    //         return {
    //           url: item.url,
    //         };
    //       });
    //     });
    // },
    //点击下载
    // onFilePreview(file) {
    //   saveAs("/Sys/File/Download?Id=" + file.url, file.name);
    // },
    //初始化附件
    // getFile() {
    //   if (
    //     this.dataForm.File === undefined ||
    //     this.dataForm.File === null ||
    //     this.dataForm.File == ""
    //   ) {
    //     return;
    //   }
    //   this.fileList = JSON.parse(this.dataForm.File);
    //   this.hideUploadEdit = true;
    // },
    //图片初始化
    getImg() {
      let that = this;
      if (that.dataForm.HeadImge || that.dataForm.HeadImge != null) {
        let params = { Id: that.dataForm.HeadImge };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              that.pictureList.push({
                url: item.Url,
                name: item.FileName,
              });
            });
          }
        });
      }
    },
    //图片查看
    onPicPreview(file) {
      let that = this;
      that.dialogImageUrl = file.url;
      that.dialogVisible = true;
    },
    //加载文件
    getFile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        // let params = { Id: that.dataForm.File };
        // api.QueryBigSickApplyFileByIds(params).then((res) => {
        //   if (res.data.Code == 0) {
        //     let fileList = res.data.Data;
        //     fileList.forEach((item) => {
        //       that.fileList.push({
        //         url: item.Url,
        //         name: item.FileName,
        //       });
        //     });
        //   }
        // });
        this.fileList = JSON.parse(this.dataForm.File);
      }
    },
    //附件下载
    onFilePreview(file) {
      // saveAs(file.url, file.name);
      saveAs("/api/File/Download?Id=" + file.url, file.name);
    },
    //初始化视频
    getVideo() {
      let that = this;
      if (that.dataForm.Video || that.dataForm.Video != null) {
        let params = { Id: that.dataForm.Video };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let videoList = res.data.Data;
            videoList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.videoList.push({
                url: item.Url,
                name: item.FileName,
                storePath: item.StorePath,
                response: response,
              });
            });
          }
        });
      }
    },
    onVideoPreview(file) {
      let that = this;
      that.showVideo = true;
      that.dialogVideoUrl='/Files'+file.storePath;
      // that.dialogVideoUrl = file.url;
    },
  },
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.el-form >>> .el-form-item {
  margin-bottom: 0;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}
.hideButton .el-button--primary {
  display: none;
}
</style>
